import { useSelector } from "react-redux";

export default function useCurrentUser () {
  const user = useSelector(({ CurrentUser }) => CurrentUser?.currentUser);
  return user
}